export const ON_ROUTE_STATUS = 1;
export const SEPARATION_STATUS = 2;

export const EVALUATION_STATUS = {
  [ON_ROUTE_STATUS]: 'En ruta',
  [SEPARATION_STATUS]: 'Separación',
};
